import { useState } from 'react';
import { toast } from 'sonner';
import { supabase } from '@/lib/supabase';

interface Props {
  selectedPlans: string[];
  onAfterAction?: () => void;
}

const PlansBulkActions = ({ selectedPlans, onAfterAction }: Props) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const handleBulkSuspend = async () => {
    if (!selectedPlans.length) return;
    const client = supabase;
    if (!client) return;
    setIsProcessing(true);
    try {
      await Promise.all(
        selectedPlans.map((planId) =>
          client.functions.invoke('plan-suspend', {
            body: { plan_id: planId, reason: 'Bulk suspend from Plans grid' },
          })
        )
      );
      toast.success(`Suspended ${selectedPlans.length} plan(s)`);
      onAfterAction?.();
    } catch (error) {
      toast.error('Bulk suspend failed', {
        description: error instanceof Error ? error.message : String(error),
      });
    } finally {
      setIsProcessing(false);
    }
  };

  if (!selectedPlans.length) {
    return (
      <div className="rounded-lg border border-slate-800 bg-slate-900/40 p-4 text-sm text-slate-500">
        Select plans to perform bulk actions such as suspend or duplicate.
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3 rounded-lg border border-slate-800 bg-slate-900/60 p-4 text-sm">
      <span className="text-slate-300">{selectedPlans.length} plan(s) selected</span>
      <button
        type="button"
        onClick={handleBulkSuspend}
        disabled={isProcessing}
        className="rounded-md border border-amber-500 px-3 py-1 text-amber-300 hover:bg-amber-500/10 disabled:opacity-50"
      >
        Suspend selected
      </button>
    </div>
  );
};

export default PlansBulkActions;
